import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function HeroBanner() {
  const hotArticles = articles.filter((a) => a.isHot).slice(0, 1);
  const featuredArticle = hotArticles[0] || articles[0];

  return (
    <section className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center overflow-hidden" aria-labelledby="hero-heading">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20abstract%20digital%20art%20composition%20with%20dramatic%20neon%20lime%20green%20accents%20and%20deep%20shadows%2C%20modern%20Chinese%20internet%20culture%20aesthetic%2C%20glowing%20particles%20and%20data%20streams%2C%20cinematic%20atmosphere%2C%20editorial%20background%20photography%2C%20high%20contrast%2C%20mysterious%20moody%20lighting%2C%20abstract%20shapes%20suggesting%20digital%20gossip%20and%20trending%20topics%2C%20no%20text%20or%20faces%2C%20pure%20atmospheric%20background&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
          aria-hidden="true"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 pt-24 pb-16 md:pt-28 md:pb-20">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row lg:items-end gap-8 lg:gap-16">
            <div className="lg:w-1/2">
              <div className="flex items-center gap-2 mb-4">
                <span className="px-3 py-1 text-xs font-label font-bold bg-accent-500 text-foreground-950 rounded-full whitespace-nowrap">
                  {featuredArticle.isExclusive ? '🔥 独家爆料' : '🔥 热门事件'}
                </span>
                <span className="text-xs text-background-50/70 font-label">{featuredArticle.date}</span>
              </div>
              <h1 id="hero-heading" className="font-heading font-black text-3xl md:text-5xl lg:text-6xl text-background-50 leading-tight tracking-tight mb-4">
                {featuredArticle.title}
              </h1>
              <p className="text-sm md:text-base text-background-50/80 leading-relaxed mb-6 max-w-lg">
                {featuredArticle.summary}
              </p>
              <Link
                to={`/article/${featuredArticle.id}`}
                className="inline-flex items-center gap-2 text-sm md:text-base font-label font-bold text-accent-400 hover:text-accent-300 transition-colors group cursor-pointer"
              >
                阅读全文
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
              </Link>
            </div>

            <div className="lg:w-1/2">
              <div className="hidden lg:block">
                <p className="text-sm text-background-50/60 font-label mb-2">阅读量</p>
                <p className="font-heading font-black text-4xl text-accent-400 mb-1">
                  {(featuredArticle.readCount / 10000).toFixed(1)}万
                </p>
                <div className="flex items-center gap-2 mt-4">
                  {featuredArticle.tags.map((tag) => (
                    <span key={tag} className="px-2.5 py-1 text-xs font-label text-background-50/70 border border-background-50/20 rounded-full whitespace-nowrap">
                      #{tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 z-10">
        <div className="max-w-7xl mx-auto px-4 md:px-8 pb-6 md:pb-8">
          <div className="hidden md:flex items-center gap-4">
            <div className="flex items-center gap-2 text-background-50/60 text-xs font-label">
              <i className="ri-flashlight-line"></i>
              <span>实时热度</span>
            </div>
            <div className="flex-1 h-0.5 bg-background-50/15 rounded-full overflow-hidden">
              <div className="h-full w-3/4 bg-accent-500 rounded-full"></div>
            </div>
            <span className="text-xs font-label font-bold text-accent-400 whitespace-nowrap">持续追踪中</span>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background-50 to-transparent z-[5]"></div>
    </section>
  );
}